<template>
  <NuxtLayout>
    <div class="article_page">
      <div class="navigation">
        <el-breadcrumb :separator-icon="ArrowRight">
          <el-breadcrumb-item :to="{ path: '/' }">
            首页
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/article/list' }">
            新闻资讯
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <div class="now_title">
              {{ map.info.title }}
            </div>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div
        v-if="map.info.id"
        v-loading="ctrl.loading"
        class="content"
      >
        <div class="detail">
          <div class="top">
            <p>{{ map.info.title }}</p>
            <div class="count">
              <span class="time">{{ map.info.artTime }}</span>
              <span>{{ map.info.readCount }}人已浏览</span>
            </div>
          </div>
          <div class="bottom rich-text">
            <p
              v-if="map.info.summary"
              class="summary"
            >
              摘要：{{ map.info.summary }}
            </p>
            <div
              class="text"
              v-html="map.info.content"
            />
          </div>
        </div>
        <div class="hot">
          <div class="block">
            <p class="recommend">
              相关推荐
            </p>
            <template v-if="map.recommendList.length > 0">
              <div
                v-for="(i,index) in map.recommendList"
                :key="index"
                class="item"
                @click="viewDetail(i.id)"
              >
                <p class="title">
                  {{ i.title }}
                </p>
                <p class="c_999 tx-ov flex-item">
                  {{ i.readCount }}人已浏览
                </p>
              </div>
            </template>
            <div
              v-else
              class="no_data"
            >
              暂无数据
            </div>
          </div>
          <div class="holder" />
          <div class="block">
            <p class="recommend">
              热门推荐
            </p>
            <template v-if="map.hotList.length > 0">
              <div
                v-for="(i,index) in map.hotList"
                :key="index"
                class="item"
                @click="viewDetail(i.id)"
              >
                <p class="title">
                  {{ i.title }}
                </p>
                <p class="c_999 tx-ov flex-item">
                  {{ i.readCount }}人已浏览
                </p>
              </div>
            </template>
            <div
              v-else
              class="no_data"
            >
              暂无数据
            </div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
import { ArrowRight } from '@element-plus/icons-vue'
import { articleHot, articleRecommend, articleView } from '../../api/article.js'
import { forbidCopy } from '@/utils'
import cookie from '@/utils/cookies'
import { parseTime } from '@/utils/index.js'

const route = useRoute()
const router = useRouter()
const cookieData = cookie.getShop()
const nowDay = new Date().getTime()
const beginTime = parseTime(nowDay - 30 * 24 * 60 * 60 * 1000)
const { data, pending } = await useAsyncData('articleView', ({ ssrContext }) => {
  const param = {
    id: route.query.id
  }
  if (process.server) {
    param.websiteDomain = ssrContext.event.req.headers.host
  } else {
    param.websiteDomain = window.location.origin
  }
  return new Promise(async (resolve) => {
    // 课程列表的请求
    Promise.allSettled([
      articleView(param),
      articleHot({ size: 6, beginTime }),
      articleRecommend({ size: 6, beginTime, articleId: route.query.id })
    ]).then(([articleInfo, hotList, recommendList]) => {
      const data = {}
      if (hotList.status === 'fulfilled') {
        data.hotList = hotList.value
      } else {
        data.hotList = []
      }

      if (articleInfo.status === 'fulfilled') {
        data.articleInfo = articleInfo
      } else {
        data.articleInfo = {}
      }

      if (recommendList.status === 'fulfilled') {
        data.recommendList = recommendList.value
      } else {
        data.recommendList = []
      }
      resolve(data)
    })
  })
}, { initialCache: false })

const map = reactive({
  info: {},
  id: '',
  hotList: [],
  recommendList: []
})

const ctrl = reactive({
  loading: false
})

let articleInfo = {}
if (!pending.value && data.value) {
  const d = data.value
  map.hotList = d.hotList
  map.recommendList = d.recommendList
  map.info = d.articleInfo.value
  articleInfo = d.articleInfo
}

useHead({
  title: computed(() => `${articleInfo.value.browserTitle ? articleInfo.value.browserTitle : articleInfo.value.title}-${cookieData.shopName}`),
  meta: [{
    hid: 'keywords',
    name: 'keywords',
    content: articleInfo.value.keywords || articleInfo.value.title
  },
  {
    hid: 'description',
    name: 'description',
    content: articleInfo.value.detailsDescribe ? articleInfo.value.detailsDescribe : articleInfo.value.title
  }]
})

watch(
  route, async () => {
    if (route.query.id !== map.id) {
      map.id = route.query.id
      if (!map.id) return
      const articleInfo = await articleView({ id: route.query.id, websiteDomain: window.location.origin })
      useHead({
        title: computed(() => `${articleInfo.title ? articleInfo.title : '资讯详情'}-${cookieData.shopName}`),
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: articleInfo.title
          },
          {
            hid: 'description',
            name: 'description',
            content: articleInfo.summary ? articleInfo.summary : articleInfo.title
          }
        ]
      })
      map.info = articleInfo
      getHotList()
    }
  }
)

const viewDetail = (id) => {
  router.push({
    path: '/article/view',
    query: {
      id
    }
  })
}

const getHotList = () => {
  articleHot({ size: 6, beginTime }).then(res => {
    map.hotList = res || []
  })
}

const getRecommendList = () => {
  articleRecommend({ size: 6, beginTime, articleId: route.query.id }).then(res => {
    map.recommendList = res || []
  })
}
onMounted(() => {
  if (map.info.enableForbidContentCopy) {
    forbidCopy('.content')
    forbidCopy('.now_title')
  }
})

</script>

<style lang="scss" scoped>
.article_page {
  width: 1200px;
  margin: auto;
  margin-bottom: 40px;
}

.navigation {
  margin: 17px 0;

  :deep(.el-breadcrumb__inner) {
    color: #999;
  }

  :deep(.el-breadcrumb__inner.is-link) {
    font-weight: normal;
  }

  .now_title {
    width: 113px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
  }
}

.content {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.detail {
  width: 820px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 5px;

  .top {
    padding: 20px;
    border-bottom: 1px solid #EBEEF5;

    p {
      font-size: 24px;
    }

    .count {
      margin-top: 10px;
      color: #999999;
    }

    .time {
      position: relative;
      margin-right: 28px;

      &::after {
        content: '';
        position: absolute;
        right: -14px;
        top: 4px;
        width: 1px;
        height: 10px;
        background: #999;
      }
    }
  }

  .bottom {
    padding: 30px;
    min-height: 305px;

    .summary {
      padding-bottom: 20px;
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 32px;
      border-bottom: 1px solid #EBEEF5;
    }

    .text {
      font-size: 16px;
      line-height: 32px;
    }
  }
}

.hot {
  width: 360px;
  // position: fixed;
  // top: 113px;
  // right: calc((100% - 1200px) / 2);
  background: #f6f8fb;
  border-radius: 5px;
  box-sizing: border-box;

  .block {
    //min-height: 300px;
    background-color: #fff;
    padding: 12px 15px 15px 15px;
  }

  .recommend {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .no_data {
    color: #999;
    text-align: center;
    //line-height: 353px;
  }

  .item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 19px;
    cursor: pointer;

    .title {
      width: 230px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }

    &:last-child {
      margin-bottom: 0px;
    }

    &:hover p {
      color: #2256F6;
    }
  }

  .holder {
    height: 20px;
    background-color: #f6f8fb;
  }
}

</style>
<style>
.rich-text ul li {
  position: relative;
}

.rich-text ul li:before {
  content: "";
  position: absolute;
  left: -15px;
  width: 10px;
  top: 30%;
  height: 10px;
  border-radius: 50%;
  background-color: #333333;
}
</style>
